import axios from "axios";

const eurekaServer = import.meta.env.VITE_EUREKA_SERVER
if (eurekaServer) {
    console.log(`Eureka server set to ${eurekaServer}`);
}
else {
    console.log(`Eureka server not set.`);
}

let servers = [
    eurekaServer || import.meta.env.VITE_API,
];

let current = 0;
function getNextServer() {
  const server = servers[current];
  current = (current + 1) % servers.length;
  return server;
}

const instance = axios.create();

if (import.meta.env.PROD) {
    instance.interceptors.request.use(config => {
        config.baseURL = getNextServer();
        return config;
      }, error => Promise.reject(error));
}
else {
    instance.defaults.baseURL = import.meta.env.VITE_API;
    console.log(`Using server ${import.meta.env.VITE_API}.`)
}

function refreshServersList() {
    instance.get(`${eurekaServer}/servers`).then((response) => {
        const newServers = response.data.servers;
        if (newServers.length > 0) {
            console.log(`All available servers: ${newServers}`);
            servers = [...newServers];
            console.log(`Updated servers list: ${servers}`);
        } else {
            console.log(`No servers received from Eureka.`);
        }
    })
    .catch((error) => {
        console.error(`Error fetching servers from Eureka: ${error}`);
    });
}

export default instance;
export { refreshServersList };